<template>
  <div class="flx flx-jcc flx-w mv paging pv_2">
    <ul class="list list--inline ta-c">
      <li class="previous">
        <a
          v-if="paging.currentpage > 0"
          class="block lh2 ph_2 pv_4"
          href="#"
          @click.prevent="gotoPreviousPage"
          >Previous</a
        >
        <span v-if="paging.currentpage <= 0" class="block lh2 ph_2 pv_4"
          >Previous</span
        >
      </li>

      <li :class="{ current: paging.currentpage === 0 }">
        <a class="block lh2 ph_2 pv_4" :class="{ 'c-white': paging.currentpage === 0 }" href="#" @click.prevent="gotoPage(1)"
          >1</a
        >
      </li>
      <li v-if="paging.currentpage > 2" class="jump">
        <span class="">…</span>
      </li>
      <li
        v-for="index in pagingNumbers"
        :key="`paging-${index}`"
        :class="{ current: paging.currentpage + 1 === index }"
      >
        <a
          class="block lh2 ph_2 pv_4"
          :class="{ 'c-white': paging.currentpage + 1 === index }"
          href="#"
          @click.prevent="gotoPage(index)"
          >{{ index }}</a
        >
      </li>
      <li
        v-if="paging.currentpage < totalpages - 3 && totalpages !== 4"
        class="jump"
      >
        <span>…</span>
      </li>
      <li :class="{ current: paging.currentpage + 1 === totalpages }">
        <a
          class="block lh2 ph_2 pv_4"
          :class="{ 'c-white': paging.currentpage + 1 === totalpages }"
          href="#"
          @click.prevent="gotoPage(totalpages)"
          >{{ totalpages }}</a
        >
      </li>
      <li class="next">
        <a
          v-if="paging.currentpage + 1 < totalpages"
          class="block lh2 ph_2 pv_4"
          href="#"
          @click.prevent="gotoNextPage"
          >Next</a
        >
        <span
          v-if="paging.currentpage + 1 >= totalpages"
          class="block lh2 ph_2 pv_4"
          >Next</span
        >
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Paging',
  props: {
    paging: {
      type: Object,
      required: true,
    },
  },
  computed: {
    totalpages: function() {
      return Math.ceil(this.paging.totalitems / this.paging.pagesize)
    },
    pagingNumbers: function() {
      let numbers = new Array()

      let maxPageNumber = this.paging.currentpage + 2
      if (this.paging.currentpage === 0) {
        maxPageNumber = this.paging.currentpage + 3
      }
      for (let i = this.paging.currentpage; i <= maxPageNumber; i++) {
        if (i > 1 && i < this.totalpages) {
          numbers.push(i)
        }
      }
      return numbers
    },
  },
  methods: {
    gotoPreviousPage: function() {
      if (this.paging.currentpage > 0) {
        this.paging.currentpage--
        this.$emit('paging')
      }
    },
    gotoNextPage: function() {
      if (this.paging.currentpage < this.totalpages) {
        this.paging.currentpage++
        this.$emit('paging')
      }
    },
    gotoPage: function(page) {
      this.paging.currentpage = page - 1
      this.$emit('paging')
    },
  },
}
</script>
